export class Company {
    companyId: number;
    name: string;
    location: string;
    createdDate: Date;
    typeOf: string;
} 